import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';
import { PAYMENTS_LOCAL_API_REQUESTS } from './utils/constants';

/**
 * Told to the server once the payer is back from their bank. Some providers
 * need an explicit hand-off after SCA before the instruction is submitted.
 */
export const completeInvoicePayment = async (
  projectId,
  invoiceId,
  activeEmployerInfo = {}
) => {
  const apiPath = `invoice/${projectId}/${invoiceId}/payment/complete`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: {},
    activeEmployerInfo,
    isLocalApiRequest: PAYMENTS_LOCAL_API_REQUESTS,
  });

  const response = await axios(signedRequest);

  return response.data;
};
